import { overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverrideLite';
import TextFieldWithLabelAbove from 'Components/ComponentLibrary/Components/Uncategorized/TextFieldWithLabelAbove';
import SelectFieldWithLabelAbove from 'Components/ComponentLibrary/Components/Uncategorized/SelectFieldWithLabelAbove';
import {
  DigitalOnboardingBalanceSheetOverride,
} from 'Views/Page/Content/Templates/DigitalOnboardingAccountInfo/metaOverride';
import fr from 'facet-rest';

export const DigitalOnboardingRealAssetInfoOverride = fr.metaOverride({ base: DigitalOnboardingBalanceSheetOverride })
  .nameOverride(['purchaseYear'], {
    _component: () => TextFieldWithLabelAbove,
  }, overrideReadOnly)
  .nameOverride(['state', 'subType', 'realAssetSubType'], {
    _component: () => SelectFieldWithLabelAbove,
  }, overrideReadOnly)
  // I can't change the real asset resource because it's already in use in other places.
  // But we're not supposed to let members adjust the type (not the subtype within the larger type, but the overarching type) anymore, and the mutator doesn't handle it anyway on the backend
  .nameOverride('type', { hidden: true })
  // It's weird to just see "Sub type" without any "Type" field, and during the add step we call it Category. At the same time, I don't want to touch the existing real asset resource since it's used in other places
  .nameOverride('subType', { prompt: 'Category' });
